module.exports = __webpack_public_path__ + "img/tutorial-f05-06.22c4a92d.png";